import apiReq from 'core/api';

export interface PasswordTokenInfo {
  /** Имя пользователя, которому принадлежит токен установки пароля. */
  name: string;
}

/** `GET /auth/password/find?token=` — проверка токена и получение имени пользователя. */
export function findPasswordToken(token: string): Promise<PasswordTokenInfo | undefined> {
  return apiReq<PasswordTokenInfo>(`auth/password/find?token=${encodeURIComponent(token)}`);
}

/** `PATCH /auth/password/set` — установка пароля по токену. */
export function setPassword(token: string, password: string): Promise<unknown> {
  return apiReq('auth/password/set', 'PATCH', { token, password });
}

/** `POST /auth/password/reset-request` — запрос на сброс пароля по email. */
export function requestPasswordReset(email: string): Promise<unknown> {
  return apiReq('auth/password/reset-request', 'POST', { email });
}
